import { useState } from 'react';
import { toast } from 'react-toastify';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { Button, Dialog, Text } from 'components';
import { Field, Form, Formik } from 'formik';
import { AuthContext } from 'hooks/useAuth';
import { useContextSelector } from 'use-context-selector';
import * as Yup from 'yup';

import { registerService } from '../../../../../services/register';

const validationSchema = Yup.object().shape({
  input_observation: Yup.string().required('O campo Observação é obrigatório'),
});

export const ModalDesactiveActive = ({
  openDialogDesactiveActive,
  handleCloseDialogDesactiveActive,
  line,
}) => {
  const user = useContextSelector(AuthContext, (context) => context.user);
  const [isLoading, setIsLoading] = useState(false);

  const activeOrDesactive = () => {
    if (line && line.active === true) {
      return 'desativar';
    } else {
      return 'ativar';
    }
  };

  const handleUpdateActive = async (values) => {
    setIsLoading(true);
    toast.info('Atualizando defeito...');
    try {
      const { data } = await registerService.updateDefectActive({
        id: line.id,
        active: line.active,
        obs: values.input_observation,
        user: user.id,
      });
      toast.success('Ativo do defeito atualizado com sucesso.');
      setIsLoading(false);
      handleCloseDialogDesactiveActive();
    } catch (error) {
      console.error(error?.response?.data?.message);
      toast.error(error?.response?.data?.message);
    }
  };
  return (
    <>
      <Dialog open={openDialogDesactiveActive}>
        <Dialog.Title onClose={handleCloseDialogDesactiveActive}>Atualizar Ativo</Dialog.Title>
        <Dialog.Content>
          <Formik
            initialValues={{}}
            onSubmit={handleUpdateActive}
            validationSchema={validationSchema}
          >
            {(props) => (
              <Form>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography
                      align='center'
                      variant='h2'
                      style={{ fontSize: '24px', fontWeight: 'bold' }}
                    >
                      Deseja realmente {activeOrDesactive()} esse defeito ?
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Field
                      size='small'
                      loading={isLoading}
                      name='input_observation'
                      variant='outlined'
                      fullWidth
                      label='Observação'
                      component={Text}
                      multiline
                      minRows={5}
                    />
                  </Grid>
                  <Grid item xs={2} sm={2} md={2} lg={2}></Grid>
                  <Grid item xs={4} sm={4} md={4} lg={4}>
                    <Button
                      color='secondary'
                      fullWidth
                      onClick={handleCloseDialogDesactiveActive}
                      loading={isLoading}
                    >
                      Cancelar
                    </Button>
                  </Grid>
                  <Grid item xs={4} sm={4} md={4} lg={4}>
                    <Button fullWidth type='submit' loading={isLoading}>
                      Atualizar
                    </Button>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Dialog.Content>
      </Dialog>
    </>
  );
};
